import { addToWishlist, triggerAlert, addToCart, getRecent,validateGift,proceedToCheckout,removeFromWishlist } from "./network.js?124332292z";
let {rch_customer_eligibility,rch_product, roucha_state, rch_customer_id} = window;

let oneSize = rch_product.variants[0].option2 == "One Size";
//Some colors have '/'. Filter those out.
const removeSlashesFromVariantOptions = (v) => {
  let copy = v;
  copy.option1 = copy.option1.replace("/","");
  return copy;
};
rch_product.variants = rch_product.variants.map(removeSlashesFromVariantOptions);

let giftSelectionMode = window.location.search.indexOf("gift-selection") > -1;

//Get all available variants by color
let availableVariants = {};
rch_product.variants.forEach((item, i) => {
  if(item.available){
    if(!availableVariants.hasOwnProperty(item.option1))
      availableVariants[item.option1] = []
    availableVariants[item.option1].push(item.id);
  }
});
// console.log({availableVariants});

let variants_by_color = rch_product.variants.reduce((acc,v)=>{
  if(!acc.hasOwnProperty(v.option1))
    acc[v.option1] = [];
  acc[v.option1].push(v.id);
  return acc;
},{});

let id_to_color = rch_product.variants.reduce((acc,v)=>{
    if(!acc.hasOwnProperty(v.option1))
      acc[v.id] = v.option1;
    return acc;
  },{});

// console.log({variants_by_color});

(async()=>{
  await roucha_state.ready;

  //Add product to recently viewed
  let recent = roucha_state.get("recentlyViewed");
  recent.unshift(rch_product.handle);
  roucha_state.set({recentlyViewed : _.uniq(recent)});
  
  console.log("removed loading")

  //send klaviyo event
  klaviyoViewedProduct();

  if(oneSize){
    setTimeout(()=> {
      $(".size-block:eq(0)").click(); 
    },100)  
  }

})();

const getVariantOptions = (variant) => rch_product.options.reduce((acc,o,i)=>{
  acc[o.toLowerCase()] = variant[`option${i+1}`]
  return acc;
},{});

let styledWithMap = {};
let sizeSelected = false;
let imageSteps = 400;
let variant_id = rch_product.variants[0].id;
let variant_options = getVariantOptions(rch_product.variants[0]);
let selectedColor = null;

//Size picker
$(".size-block").click(pickSize);
function pickSize(e){
  $(".add-to-cart").addClass("size-selected");
  sizeSelected = true;
  let block = $(e.target).closest(".size-block");
  let clickedVariant = rch_product.variants.find((v) => {
    // console.log("clicked variant",v.options,block.attr("data-size"),selectedColor)
    return v.options.indexOf(block.attr("data-size")) > -1 &&
    (v.options.indexOf(selectedColor) > -1 || !selectedColor)
  })
  // $(".picked-size-description").text(block.attr("data-description"));
  switchVariant(clickedVariant.id,true);
}
//End size picker

function horizontalTemplate(p,extraClass){
  if(p.tags.map(t=>t.toLowerCase()).indexOf("HIDE-ON-PP") > -1){
    return
  }
  if(p.compare_at_price_max && p.compare_at_price_max !== "0.00"){
    p.compare_at_price = parseFloat(p.compare_at_price_max)
  }
  let imageWidth = 200+Math.ceil((window.innerWidth/5)/200)*200;
  let compare_at_price;
  if(parseFloat(p.compare_at_price_max?.maxVariantPrice?.amount) > p.price){
    compare_at_price = parseFloat(p.compare_at_price_max.maxVariantPrice.amount);
  }
  let price = compare_at_price ?
    `<span class='line-through'>$${compare_at_price> 1000 ? (compare_at_price/100).toFixed(2) : compare_at_price}</span>
      <span class='accent'>
        $${p.price > 1000 ? p.price/100 : p.price.replace(".00","").replace(".0","")}&nbsp;&nbsp;Sale
      </span>` : `<span>
        $${p.price > 1000 ? p.price/100 : p.price.toString().replace(".00","").replace(".0","")}
      </span>`
  return `<a class='horizontal-product ${extraClass}' title="1" href="${p.url}">
    <div class='horizontal-product-image' style="background-image: url(${p.featured_image ? (p.featured_image.url ? p.featured_image.url : p.featured_image):""}&width=${imageWidth})"></div>
    <div class='horizontal-product-text'>
      <div class='horizontal-product-title'>${p.title}</div>
      <div class='horizontal-product-price price-spacing'>${price}</div>
    </div>
  </a>`;
}

function switchVariant(options,force){
  if(rch_product.variants.length === 1){//if there's only one variant
    initVariant(rch_product.variants[0].id);
    return
  }
  let id;
  let new_variant_options;
  if(typeof options !== "object"){
    // console.log("param options",options)
    id = parseInt(options);
    new_variant_options = getVariantOptions(rch_product.variants.find(v=>v.id===id));

  } else {
    // console.log("switching based on ",options)
    new_variant_options = {...variant_options, ...options};
    id = getVariantIdFromOptions(new_variant_options);
  }
  if(id && id !== variant_id){
    // console.log("switched to ",id)
    variant_id = id;
    variant_options = new_variant_options;
    let newVariant = getValidVariant(variant_options)
    initVariant(id);
  } else {
    // console.log("no variant id to switch to")
    initVariant(variant_id);
  }
  $("#zoom-label").removeClass("fadeIn")
  // setTimeout(()=> {
    $("#zoom-label").addClass("fadeIn")
  // },2000)
}

const sizeSynonyms = {
    'A':"S",
    'AA':"S-S",
    'B':"M",
    'BB':"M-S",
    'C':"L",
    'D':"XL",
}

//A ?variant= link names an exact size, so pick it the way a shopper would, by
//clicking its .size-block (which also focuses the back in stock email input).
//Runs after switchVariant so pickSize matches the size within the right color.
const clickSizeFromVariant = (id) => {
  //?selectsize means the size wasn't really picked (wishlist items saved without
  //one link to an arbitrary variant), so leave the dropdown asking
  if(oneSize || new URLSearchParams(window.location.search).has("selectsize"))
    return;
  let variant = rch_product.variants.find(v => v.id === id);
  if(variant)
    $(`.size-block[data-size="${getVariantOptions(variant).size}"]`).first().click();
}

//TODO: refine this henry
const setVariantFromUrl = () => {
  if(rch_product.variants.length === 1){//if there's only one variant
    initVariant(rch_product.variants[0].id);
    return
  }
  let searchParams = new URLSearchParams(window.location.search);
  let params = {}
  let explicitVariantParam;
  for (let p of searchParams) {
    if(p[0].toLowerCase() === "size" || p[0].toLowerCase() === "color")
      params[p[0]] = p[1]
      //if variant specified, go to that exact variant
    if(p[0].toLowerCase()==="variant"){
      switchVariant(p[1]);
      clickSizeFromVariant(parseInt(p[1]));
      return;
    }
  }
  
  //check if color is sold out
  let colorInStock;
  if(params["color"]){
    let variantsInColor = rch_product.variants
        // .filter(v => v.options.map(o=>o.toLowerCase()).indexOf(params["color"].toLowerCase()) > -1)
        .filter((v) => {
            const mappedOptions = ","+v.options.map(o=>o.toLowerCase()).join()+",";
                // console.log("mapped options",mappedOptions,params["color"].toLowerCase())
                return mappedOptions.indexOf(","+params["color"].toLowerCase()+",") > -1
            })
    colorInStock = variantsInColor.some(v => v.available === true)
    if(!colorInStock){
        console.log("color not in stock",variantsInColor)
      let size = params["size"] ? params["size"] : "C";
      let nextVariant = variantsInColor.find(v => v.options.indexOf(size)>-1)?.id;
      switchVariant(nextVariant ? nextVariant : variantsInColor[0].id);
      return;
    }
  }
  let proposedVariantId = getVariantIdFromURLOptions(params)
  let proposedIndex = rch_product.variants.findIndex(v=>v.id === proposedVariantId);
  let proposedVariant = rch_product.variants[proposedIndex]
  let variantCount = proposedIndex;
  let totalVariants = rch_product.variants.length;
  while((!proposedVariant || !proposedVariant.available) && variantCount < totalVariants){
    proposedVariant = rch_product.variants[(proposedIndex+(++variantCount))%totalVariants]
  }

  // console.log("henry",proposedVariantId,proposedIndex,proposedVariant)

  switchVariant(proposedVariant.id);
}

const getValidVariant = (params) => {
  let proposedVariantId = getVariantIdFromOptions(params)
  let proposedIndex = rch_product.variants.findIndex(v=>v.id === proposedVariantId);
  let proposedVariant = rch_product.variants[proposedIndex]
  let variantCount = proposedIndex;
  let totalVariants = rch_product.variants.length;
  // console.log("before search",proposedVariantId,!proposedVariant.available)
  while((!proposedVariant || !proposedVariant.available) && variantCount < totalVariants){
    proposedVariant = rch_product.variants[(proposedIndex+(++variantCount))%totalVariants]
  }
  return proposedVariant;
}

const getVariantIdFromOptions = (options) => {
  let firstMatch;
  let variant = rch_product.variants.find(v => {
    let values = _.values(options).map(o=>o.replace("/",""));
    let filteredOptions = v.options.map(o=>o.replace("/",""));
    let matches = _.difference(filteredOptions,values).length === v.options.length-values.length;
    if(!v.available && !firstMatch){
      firstMatch = v.id
    }
    return v && v.available && matches;
  })
  return variant && variant.id ?  variant.id : firstMatch;
};

const getVariantIdFromURLOptions = (options) => {
  let firstMatch;
  // console.log("options from URL",options)
  let variant = rch_product.variants.find(v => {
    let values = _.values(options).map(o=>o.replace("/","").toLowerCase());
    let filteredOptions = v.options.map(o=>o.replace("/","").toLowerCase());
    let matches = _.difference(filteredOptions,values).length === v.options.length-values.length;
    // console.log("MATCH",v.options,filteredOptions,values)
    if(matches && !firstMatch){
      firstMatch = v.id
    }
    return v && v.available && matches;
  })
  return variant && variant.id ?  variant.id : firstMatch;
};

const getVariantFromOptions = (options) => {
  // if()
  // console.log("One size",options, typeof options.size)
  let variant = rch_product.variants.find(v => {
    let values = _.values(options).map(o=>o.replace("/",""));
    let filteredOptions = v.options.map(o=>o.replace("/",""));
    return _.difference(filteredOptions,values).length === v.options.length-values.length;
  })
  // if(!variant || !variant.available){
  //   variant = findVariantIdFromOptions(options)
  // }
  return variant && variant.id ?  variant : null;
};

const getVariantColor = (variant) => {
  let option = rch_product.options.map(o=>o.toLowerCase()).indexOf("color")+1;
  return variant[`option${option}`];
}

const getWishlistItemColor = (variant) => {
    let option = rch_product.options.map(o=>o.toLowerCase()).indexOf("color")+1;
    let fullVariant = rch_product.variants.find(v => v.id === variant.variant_id);
    return fullVariant[`option${option}`];
}

const escapeQuote = (str) => {
  const regex = /"/i;
  return str.replace(regex, '&quot;');
}

let itemsAddedToCart = []
let imageWidths;
const imageElement = (media,imagesWidth) => `<div class='product-image'><img loading="lazy" alt="${escapeQuote(media.alt)}" style="aspect-ratio:${media.aspect_ratio};" src="${media.src+`${media.src.indexOf("?") > -1 ? "&" : "?"}width=${imageWidths}`}"></img></div>`;
const zoomImageElement = (media) => `<div class='product-image product-zoom-image desktop'><img loading="lazy" alt="${escapeQuote(media.alt)}"  src="${media.src}"></img></div>`;
//the same but with "mobile" class
const mobileZoomImageElement = (media) => `<div class='product-image product-zoom-image mobile'><img loading="lazy" alt="${escapeQuote(media.alt)}"  src="${media.src}&width=1000"></img></div>`;
let hasSetStyledWith = false;

const initVariant = async (id) => {
  historyChanges++;
  let variant = window.rch_selected_variant = rch_product.variants.find(v => v.id === id);
  let variant_color = getVariantColor(variant);
  let imagesWidth = ($("#product-images").width()/window.innerWidth)*100;
  imageWidths = $("#product-images").width() > 0 ? Math.ceil($("#product-images").width()/imageSteps)*imageSteps : 600;
  let wishlist = roucha_state.get("wishlist");
  let colorVariants = variants_by_color[variant_color];
  let productInWishlist = wishlist && wishlist.length > 0 ? wishlist.filter(w => {
    return w.handle === rch_product.handle  && colorVariants.indexOf(w.variant_id) > -1
  }).length>0: false;

  if(variant_color !== selectedColor || !!!variant_color){
    let media = rch_product.media
    .filter(m => m.alt && m.alt.replace("/","").split(";")[0] === variant_color)
    // .map(m => m.src)
    .map(m=>imageElement(m,imagesWidth));
    let zoomMedia = rch_product.media
    .filter(m => m.alt && m.alt.replace("/","").split(";")[0] === variant_color)
    .map(zoomImageElement);
    let mobileZoomMedia = rch_product.media
    .filter(m => m.alt && m.alt.replace("/","").split(";")[0] === variant_color)
    .map(mobileZoomImageElement);
    setTimeout(()=> {
      $("#product-images .product-images-wrapper").html(media);
      $("#product-zoom-images .product-zoom-images-wrapper").html(zoomMedia.join("")+mobileZoomMedia.join(""));
    },10)
    selectedColor = variant_color;
  }
  if(variant.compare_at_price && variant.compare_at_price !== variant.price){
    $("#product-price .compare-at").text(`$${variant.compare_at_price/100}`);
    $("#product-price .actual-price").text(giftSelectionMode ? "$0" : `$${variant.price/100} Sale`);
    $("#product-price .actual-price").addClass("accent")
  } else {
    $("#product-price .compare-at").text("");
    $("#product-price .actual-price").text(giftSelectionMode ? "$0" : `$${variant.price/100}`);
    $("#product-price .actual-price").removeClass("accent")
  }
  if(productInWishlist){
    $(".heart").addClass("filled");
  } else {``
    $(".heart").removeClass("filled");
  }
  $("#product, .add-to-cart").attr("data-variant-id",id);
  $(".color-picker .selected").removeClass("selected");
  $(`.color-picker [clr-name="${variant_color}"]`).addClass("selected")
  $("#product-colors-label").text("COLOR: "+variant_color);
  $(".size-block.selected").removeClass("selected");
//   if we've actually clicked a size yet
  if($("#cart-add-button").hasClass("size-selected")){
    $(`[data-size="${variant_options.size}"]`).addClass("selected")
  }
  $(".picked-size-description").text($(`[data-size="${variant_options.size}"]`).attr("data-description"));
  if(!variant.available && sizeSelected){
    //set the correct sold out message to active
    $(`#sold-out-button-content .restock-message .show`).removeClass("show");
    $(`#sold-out-button-content .restock-message .restock-color-${variant_color}`).addClass("show");

    //check in bis_signups if we've already signed up for this variant
    let bis_signup = localStorage.bis_signups && JSON.parse(localStorage.bis_signups).find(b => b === variant.id);
    // console.log("bis signup",bis_signup,JSON.parse(localStorage.bis_signups),variant.id)
    if(bis_signup){
        // console.log("bis signup",bis_signup)
      $("#cart-add-button").addClass("sold-out").html($("#sold-out-success").html()).css("cursor","default");

    } else {
        // console.log("bis signup false",bis_signup)
      $("#cart-add-button").addClass("sold-out").html($("#sold-out-button-content").html()).css("cursor","revert-layer");

    }
  } else if(variant.inventory_quantity<window.stockSettings["EXPLICIT_STOCK"] && variant.inventory_quantity>0){
    $("#cart-add-button").html("ADD TO CART <span id='product-remaining'></span>");
    $("#product-remaining").text(` — Only ${variant.inventory_quantity} Left`)
    $("#cart-add-button").removeClass("sold-out");
    $("#cart-add").removeClass("added");
  } else {
    $("#cart-add-button").removeClass("sold-out");
    $("#cart-add-button").text("ADD TO CART");
    $("#cart-add").removeClass("added");
    $("#cart-add-button").css("cursor","revert-layer");
  }
  let isInCart = roucha_cart.items.map(i=>i.variant_id).concat(itemsAddedToCart).indexOf(id)>-1;
  // console.log("isInCart",isInCart)
  if(isInCart){
    $("#cart-add").addClass("added");
  } else {
    $("#cart-add").removeClass("added");
  }
  
  variant_color && setSizeQuantities(variant_color);
  if(localStorage && localStorage.wl_add){
    await productPageAddToWL();
    delete localStorage.wl_add;
  }
  
  if(localStorage && localStorage.bis_email){
    $(".back-in-stock-email").val(localStorage.bis_email);
  }
}

const setSizeQuantities = (color) => {
  let sizeQuantities = rch_product.variants
    .filter(v => v.option1 === color)
    .reduce((acc,item)=>{
      acc[item.option2] = item.inventory_quantity;
      return acc;
    },{})
  for (var size in sizeQuantities) {
    if (sizeQuantities.hasOwnProperty(size)) {
      $(`[data-size="${size}"]`).attr("data-quantity",Math.max(0,sizeQuantities[size]));
      //if quantity is less than 4, add a class "low-stock" to the size block
    //   LIMITED_STOCK
    //   FEW_LEFT
        if(sizeQuantities[size]<window.stockSettings["LIMITED_STOCK"] && sizeQuantities[size]>window.stockSettings["LOW_STOCK"]&& sizeQuantities[size]>0){
            $(`[data-size="${size}"]`).addClass("low-stock")
            $(`[data-size="${size}"]`).removeClass("limited-stock")
            $(`[data-size="${size}"]`).removeClass("explicit-stock")
        } else if(sizeQuantities[size]<=window.stockSettings["LOW_STOCK"] && sizeQuantities[size]>window.stockSettings["EXPLICIT_STOCK"] && sizeQuantities[size]>0){
            $(`[data-size="${size}"]`).addClass("limited-stock")
            $(`[data-size="${size}"]`).removeClass("low-stock")
            $(`[data-size="${size}"]`).removeClass("explicit-stock") 
        } else if(sizeQuantities[size]<=window.stockSettings["EXPLICIT_STOCK"] && sizeQuantities[size]>0){
            $(`[data-size="${size}"] .explicit-stock-alert`).text(`Only ${sizeQuantities[size]} Left`);
            $(`[data-size="${size}"]`).addClass("explicit-stock")
            $(`[data-size="${size}"]`).removeClass("low-stock")
            $(`[data-size="${size}"]`).removeClass("limited-stock")
        } else {
            $(`[data-size="${size}"]`).removeClass("explicit-stock")
            $(`[data-size="${size}"]`).removeClass("low-stock")
            $(`[data-size="${size}"]`).removeClass("limited-stock")
        } 
    }
  }
}

const setUrlParams = (query) => {
  console.log("new params ",query);
  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?"+query;
    console.log(newurl)
    window.history.pushState({path:newurl},'',newurl);
    window.onpopstate = function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("popping state")
        // history.go(-1*historyChanges);
        // Handle the back (or forward) buttons here
        // Will NOT handle refresh, use onbeforeunload for this.
    };
    // console.log()
    // window.location.search = "?"+query;
  }
}

const determineGiftLevel = () => {
  let giftLevels = $("#product").attr("data-gift-level");
  let giftLevel = 0;
  if(rch_customer_eligibility){
    console.log(rch_customer_eligibility,giftLevels)
    //get the lowest matching gift level of product and customer
    for (var i = rch_customer_eligibility.length; i > 0; i--) {
      if(giftLevels.indexOf(rch_customer_eligibility[i-1])>-1){
        giftLevel = rch_customer_eligibility[i-1]
      }
    }
  }
  // console.log("The giftLevel is ",giftLevel);
  return parseInt(giftLevel);
}

//begin form code
$("#cart-add-button").click(async function(){
  // let cartImage = $(".#product-images img:eq(0)").attr('src');
  //rch_selected_variant.featured_image.src = $("#product-images img:eq(0)").attr('src');
  if(!sizeSelected && !oneSize){
    // triggerAlert("Please Select A Size");
    $(".size-dropdown-toggle").addClass("auto-focus");
    setTimeout(()=> {
        $(".size-dropdown-toggle:eq(0)").click();
        $(".size-dropdown-toggle").removeClass("auto-focus");
    },500);
    
    return;
  }
  if($("#cart-add-button").hasClass("sold-out")){
    return;
  }
  $("#cart-add-button").addClass("loading");
  let mainElement = $("#product");
  let userEligible = roucha_state && roucha_state.hasOwnProperty("giftLevels") ? roucha_state.giftLevels
    .map(l => "reward-"+l)
    .filter(c => $("#product").hasClass(c)).length > 0 : false;

  if(mainElement.hasClass("free-gift")){// && userEligible){
    let gift = await validateGift(mainElement);
    console.log("THE GIFT!!",gift)
    if(gift.id){
      let result = await addToCart(rch_selected_variant,rch_product,gift.collectionId,gift.id);
      roucha_state.giftLevels = roucha_state.giftLevels.filter(l=>l!==gift.id)
      roucha_cart.items = roucha_cart.items.concat(result.items);
      $("#cart-add-button").removeClass("loading");
      $("#cart-add").addClass("added");
      itemsAddedToCart.push(rch_selected_variant.id)
      if(result.items){
        roucha_cart.items = roucha_cart.items.concat(result.items);
      }
      console.log("added to cart response",result)
    } else {
      triggerAlert('Unable To Add Free Gift To Your Cart');
      $("#cart-add-button").removeClass("loading");
    }
  }
  else {
    let result = await addToCart(rch_selected_variant,rch_product);
    $("#cart-add-button").removeClass("loading");
    $("#cart-add").addClass("added");
    itemsAddedToCart.push(rch_selected_variant.id)
    if(result.items){
      roucha_cart.items = roucha_cart.items.concat(result.items);
    }
    console.log("added to cart response",result)
    $("#mini-cart-scroll").html($(result.sections['mini-cart-section']).find("#mini-cart-scroll").html())
  }

    let matchingWishlistItems = roucha_state.get("wishlist").filter(w => w.handle === rch_product.handle && variants_by_color[rch_selected_variant.option1].indexOf(w.variant_id) > -1);
    if(matchingWishlistItems.length > 0){
        //if there are matching color variants in the wishlist, remove them
        let results = await Promise.all(
            matchingWishlistItems.map(w => removeFromWishlist(roucha_state.get("id"),w.variant_id.toString()).then(response =>{
                if(response.customer){
                    let newLocalState = roucha_state.local;
                    let {wishlist} = newLocalState;
                    newLocalState.wishlist = wishlist.filter(v => v.variant_id !== parseInt(w.variant_id))
                    roucha_state.set({wishlist: wishlist.filter(v => v.variant_id !== parseInt(w.variant_id))});
                }
                return response;
            }))
        );
        console.log("removed wishlist items",results,roucha_state.get("id"),matchingWishlistItems[0].variant_id)
        //also remove it from roucha_state.wishlist array

    }
})
//end cart add button click

let zoomIsOn = false;
const setZoomLabelPosition = (x,y,important) => {
  $("#zoom-label").css({
    top: y+"px"+(important ? "!important" : ""),
    left: x+"px"+(important ? "!important" : "")
  })
}
const setZoomLabelText = (text) => {
  $("#zoom-label").text(`${zoomIsOn ? "" : ""} ZOOM${text.indexOf("GHOST") === -1 && text.indexOf(";") > -1 ? ", " + text.slice(text.indexOf(";")+1) : ""}`)
}

$(document).on("click","#product-images .product-image",(e)=>{
  let index = $(e.target).closest(".product-image").index();
  const mobile = window.innerWidth < 768;
  $("#product-zoom-images").addClass("active");
  $(`.product-zoom-images-wrapper ${mobile ? ".mobile" : ".desktop"}.product-image:eq(${index})`)[0].scrollIntoView()
  zoomIsOn = true;
  updateZoomLabelState();
  setZoomLabelPosition(e.clientX,e.clientY,true);
  setZoomActive(true);
})

$(document).on("click","#product-zoom-images.active ,#product-zoom-images .x",(e) => {
  $("#product-zoom-images").removeClass("active");
  zoomIsOn = false;
  updateZoomLabelState();
  setZoomLabelPosition(-1000,-1000);
  setZoomActive(false);
});

$(document).on( "mouseenter","#product-zoom-x",()=>{
  setZoomLabelPosition(-1000,-1000);
})

async function productPageAddToWL(){
  $("#wishlist-add-button").addClass("loading");
  $(`[name="return_to"]`).remove();//.attr("value",window.location.pathname);
  $("#customer_login").append(`<input type="hidden" name="return_to" value="${window.location.pathname}">`)
  let data;
  const item = {
    handle: rch_product.handle,
    title: rch_product.title,
    variant_id: null,//rch_selected_variant.id,
    inventory: null,//rch_selected_variant.inventory_quantity,
    price: `${rch_selected_variant.price / 100}`,
    compare_at_price: `${rch_selected_variant.compare_at_price / 100}`,
  };
  try {
   data = await addToWishlist(rch_selected_variant,rch_product, false);
  } catch (e) {
    console.log("ohhh2")
    triggerAlert(e);
  } finally {
    $("#wishlist-add-button").removeClass("loading");
  }
}

$("#wishlist-add-button").click(async function(){
  productPageAddToWL();
  // if(data)
  //   triggerAlert("Added to wishlist");
})

$(".proceed-to-checkout").click(async function(e){
//   $(e.target).addClass("loading")
  // proceedToCheckout();
  window.location = "/cart"
})

//when click a .heart, if it has class filled, remove from wishlist, else add to wishlist
$(document).on("click",".heart",async function(e){
  e.preventDefault();
  e.stopPropagation();
  if(roucha_state.get("id")){
      } else {
      $("#login").click();
      return;
  }
  console.log("auto added wishlist heart event ",e);
  if($(e.target).closest(".heart").hasClass("filled")){
    $(".heart").removeClass("filled");
    //find every wishlist item with the same product handle and variant color
    let wishlistMatches = roucha_state.get("wishlist").filter(w => w.handle === rch_product.handle && getWishlistItemColor(w) === getVariantColor(rch_selected_variant));
    console.log("wishlist matches",wishlistMatches)
    let results = await Promise.all(wishlistMatches.map(w => removeFromWishlist(roucha_state.get("id"),w.variant_id)))
    results.map((result,i) => {
      if(result.customer){
        let newLocalState = roucha_state.local;
        let {wishlist} = newLocalState;
        newLocalState.wishlist = wishlist.filter(v => v.variant_id !== parseInt(wishlistMatches[i].variant_id))
        // console.log(variantId,newLocalState.wishlist)
        roucha_state.set({wishlist: wishlist.filter(v => v.variant_id !== parseInt(wishlistMatches[i].variant_id))});
        console.log(newLocalState)
        triggerAlert("Removed From Wishlist") 
      } else {
        triggerAlert("There Was A Problem Removing This Product.")
      }
    })
    
  } else {
    $(".heart").addClass("filled");
    let data = await addToWishlist(rch_selected_variant,rch_product,false);
    console.log("add to wishlist",data)
  }
});

$(".color-choice").click((e)=>{
  e.preventDefault()
  var displayName = $(e.target).attr("clr-name");
  //switch choices
  $(e.target).parent().find(".selected").removeClass("selected");
  $(e.target).addClass("selected")
  let currentSize = $(".size-block.selected").attr("data-size") || "One Size"
  let firstVariantTry = getVariantFromOptions({color: displayName,size: currentSize});
  if(firstVariantTry && firstVariantTry.available){
    switchVariant(firstVariantTry.id);
  } else {
    if(availableVariants[displayName]){
      let next = availableVariants[displayName][0];
      switchVariant(next);
    } else {
      // switchVariant(firstVariantTry.id);
        //just switch to the first variant in the color even if its unavailable
        let next = rch_product.variants.find(v => v.option1 === displayName);
        switchVariant(next.id);
    }
  }
  let params = new URLSearchParams(window.location.search);
  params.set("color", displayName)
  params.delete("variant")
  console.log("params",params)
  setUrlParams(params.toString())
  $(".product-images-wrapper")[0].scrollTo(0,0);
  $("#product-images")[0].scrollTo(0,0);
  // window.location.search = params.toString();
});
// end form code


(async()=>{
  //RECENT
  await roucha_state.ready
  if(roucha_state.get("recentlyViewed").length > 6){
    let results = await getRecent(roucha_state.get("recentlyViewed").slice(0,10))
    //filter out any products containing the tag "hide-on-pp"
    results = results.filter(p => p.tags.map(t=>t.toLowerCase()).indexOf("HIDE-ON-PP") === -1)
    if(results.length){
      console.log("recent results",{results})
      let tiles = results.slice(1).map(p => horizontalTemplate(p))
      if(results.length>5){
        $("#product-recent .products-horizontal").html(tiles.join(""));
      } else {
        for (var i = 0; i < 10-results.length; i++) {
          tiles.unshift($(`#product-recent .product-horizontal:eq(${i})`).html())
        }
        $("#product-recent .products-horizontal").html(tiles.join(""));
      }

      // console.log({results})
    }
  } else {
    //show best sellers
  }
})();

let ctx;
let gutter,btnW,btnH,scrollW,trackH;
let area;

var pixelRatio;
function setCanvasScalingFactor() {
   return window.devicePixelRatio || 1;
}

if(window.innerWidth<768){
  pixelRatio = setCanvasScalingFactor();
  let canvas = document.querySelector(".canvas-scroller");
  area = {
    w: $(".canvas-scroller").width()*pixelRatio,
    h: $(".canvas-scroller").height()*pixelRatio
  }
  canvas.setAttribute('width', area.w);
  canvas.setAttribute('height', area.h);
  gutter = 0;//area.w*.1;
  btnW = Math.floor(window.innerWidth*.2);
  btnH = 20;
  trackH = 3;
  scrollW = area.w - gutter*2;
  ctx = canvas.getContext("2d");
  ctx.strokeStyle = "#bb9f8e";
  handleScrollOnCanvas(0);
  $("#product-images").scroll((e)=>{
    let percent = $("#product-images").scrollLeft()/($(".product-images-wrapper").width()-window.innerWidth)
    if(percent<0) percent = 0;
    if(percent>1) percent = 1;
    console.log(percent)
    handleScrollOnCanvas(percent);
  });
  function startup() {
    canvas.addEventListener("touchmove", handleCanvasDrag, false);
  }
//   document.addEventListener("DOMContentLoaded", startup);
}

let isDragging = false;

$(".canvas-scroller").mousedown(function(e) {
    isDragging = true;
    console.log(e.offsetX/e.target.offsetWidth)
    let percent = ((e.offsetX-30)/(e.target.offsetWidth-60));
    if(percent<0) percent = 0;
    if(percent>1) percent = 1;
    handleScrollOnCanvas(percent);
    $("#product-images")[0].scrollTo(percent*($(".product-images-wrapper").width()-window.innerWidth),0)
})
.mousemove(function(e) {
    if(!isDragging){
      return;
    }
    let percent = ((e.offsetX-30)/(e.target.offsetWidth-60));
    if(percent<0) percent = 0;
    if(percent>1) percent = 1;
    handleScrollOnCanvas(percent);
    $("#product-images")[0].scrollTo(percent*($(".product-images-wrapper").width()-window.innerWidth),0)
 })
.mouseup(function() {
    var wasDragging = isDragging;
    isDragging = false;
    // if (!wasDragging) {
        // $("#throbble").toggle();
}).mouseleave(function(e){
  // isDragging = false;
});

function handleScrollOnCanvas(percent){
  if(!ctx)
    return;
    ctx.fillStyle= "white";
    ctx.fillRect(0,0,768*pixelRatio,60);
    ctx.fillStyle= "#bb9f8e";
    ctx.fillRect(btnW/2,30-trackH/2,scrollW-(btnW),trackH); //scroll track
    ctx.fillRect(gutter+(percent*((scrollW-btnW))),30-(btnH/2),btnW,btnH); //scroll thumb
}

function handleCanvasDrag(e){
  e.preventDefault();
  e.stopPropagation()
  let percent = Math.max(0,Math.min(1.1111*pixelRatio*((e.layerX-(pixelRatio*btnW/2))/area.w),1));
  $("#product-images")[0].scrollTo(percent*$(".product-images-wrapper").width(),0)
}

function klaviyoViewedProduct(){
  if (window._learnq) {
      const item = {
        Name: rch_product.title,
        ProductID: rch_product.id,
        ImageURL: `https:${rch_product.images[0]}`,
        URL: window.location.href,
        Brand: rch_product.vendor,
        Price: `$${rch_product.price / 100}`,
        CompareAtPrice: `$${rch_product.compare_at_price / 100}`,
        Categories: rch_product.tags,
      };
      window._learnq.push(['track', 'Viewed Product', item]);
      window._learnq.push(['trackViewedItem',
        {
          Title: item.Name,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: {
            Brand: item.Brand,
            Price: item.Price,
            CompareAtPrice: item.CompareAtPrice,
          },
        },
      ]);
    }
}
document.onkeydown = function(e) {
  if(e.which == 27){
    $("#product-zoom-images").removeClass("active");
    zoomIsOn = false;
    updateZoomLabelState();
    setZoomActive(false);
    e.preventDefault();
    e.stopPropagation();
  }

};

function setZoomActive(isActive) {
  if (isActive) {
    $("#zoom-label").addClass("zooming");
  } else {
    $("#zoom-label").removeClass("zooming");
  }
}

const updateZoomLabelState = () => {
  let zoomText = $("#zoom-label").text();
  $("#zoom-label").text((zoomIsOn ? "" : "")+zoomText.slice(1))
}

const ensureColorLabelsShowing = () => {
  //#product-colors bounding rect
  let parentBox = $("#product-colors")[0].getBoundingClientRect();
  $(".left-overflow").removeClass("left-overflow");
  $(".right-overflow").removeClass("right-overflow");
  let innerW = window.innerWidth;
  let labels = $(".color-label");
  let cutoffLabels = labels.each((i,l) => {
    let {x,width} = l.getBoundingClientRect();
    if(x < parentBox.x){
      l.classList.add("left-overflow");
    } else if ((x+width)>parentBox.x+parentBox.width){
      l.classList.add("right-overflow");
    }
    //show the label
    l.classList.add("ready");
  });

}
// addToWishlist(rch_product,variant);
let historyChanges = -1;
$(document).ready(()=> {
    //if user logs in on product page, send them back to this page
  $("#customer_login").append(`<input type="hidden" name="return_to" value="${window.location.pathname}">`)
  setVariantFromUrl();

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("selectsize")) {
    setTimeout(() => {
        $(".size-dropdown-toggle:eq(0)").click();
    }, 100);
}

  //pretty sure this does nothing
  let giftLevel = determineGiftLevel();
  if(giftLevel>0){
    $("#product").addClass("isGift");
    $("#product").attr("data-gift-level",giftLevel);
    $("#product").attr("data-gift-collection",giftLevels.find(l=>l.id===giftLevel).collectionId);
  }
  // end pretty sure this does nothing

  $(window).on("popstate", function(e) {
    $(e.preventDefault())
    setVariantFromUrl();
  });

  function registerZoomListeners(){

  }

  // let moveCount = 0;
  // let moveInterval = 2;
  if(window.innerWidth > 768){
    $(document).on("mouseenter",".product-images-wrapper img, .product-zoom-images-wrapper img",e => {
    //   setZoomLabelText($(e.target).attr("alt"))
    })
    // $(document).on("mouseleave",".product-images-wrapper img, .product-zoom-images-wrapper img",e => {
    //   console.log(e.target)
    // })
    $(document).on("mousemove",".product-images-wrapper img, .product-zoom-images-wrapper img",e => {
      // $("#product-zoom").addClass("fadeIn")
      setZoomLabelPosition(e.clientX,e.clientY);
    })
    $(document).on("mouseleave",".product-images-wrapper",()=>{
      if(!$("#product-zoom-images").hasClass("active"))
      setZoomLabelPosition(-1000,-1000);
      $("#product-zoom").removeClass("fadeIn")
    })
  }
  ensureColorLabelsShowing();

  //DESCRIPTION STUFF
  $("#product-description").html(leafify("#product-description").map(l => l.outerHTML).join(""));
  parseProductDescription("#product-description");

  let deletions = []; $("#product-description span").each((i,e)=>{
    if($(e).html() === "<br>"){
        deletions.push(e)
    }
})
deletions.forEach(e => e.remove())
$(".product-description-content > br:first-child").remove()

  $(".product-description-section").click((e)=>{
    e.preventDefault();
    // if we didn't click a link
    if($(e.target).closest("a").length){
      return;
    }
    
    $(e.target).closest(".product-description-section").toggleClass("open");
  });
})

function leafify(selector){
    //recursively traverse the element
    //if theres ONLY ONE childNode and its a text node, return the whole element
    //if theres more than one childNode, return an array of leafs. the text nodes should be spans, and we should traverse the element nodes
    let wrapper = $(selector);
    let children = wrapper[0].childNodes;
    let leafs = [];
    if(children.length === 1 && children[0].nodeType === 3){
        leafs.push(wrapper[0]);
    } else {
        children.forEach(c => {
            if(c.nodeType === 3){
                let span = document.createElement("span");
                span.innerText = c.nodeValue;
                leafs.push(span);
            } else if(c.nodeName === "BR"){
                let br = document.createElement("br");
                // span.innerText = "BREAK";
                leafs.push(br);
            }else {
                leafs = leafs.concat(leafify(c));
            }
        });
    }
    return leafs;
}

function hasLetters(str){
    return str.match(/[a-z]/i);
}

function parseProductDescription(selector){
    let wrapper = $(selector);
    //for all of wrapper's children, determine if element is a header or content element. the test is if all the innerText is uppercase
    let children = wrapper.children();
    let sections = [];
    let firstItems = [];
    children.each((i,c) => {
        // console.log(c.innerText,c.innerText === c.innerText.toUpperCase() && c.innerText !== "\n" && hasLetters(c.innerText))
        if(c.innerText.length > 3 && c.innerText === c.innerText.toUpperCase() && c.innerText !== "\n" && hasLetters(c.innerText)){
            sections.push({
                header: c.innerText.replace("BREAK",""),
                content: []
            })
        } else {
            if(sections.length){
                sections[sections.length-1].content.push(c)
            } else {
                firstItems.push(c)
            }
            
        }
    });
    let height = wrapper.height();
    let width = wrapper.width();
    wrapper.width = width;
    wrapper.height = height;
    wrapper.html(firstItems.map(i=>i.outerHTML).join(""));
    sections.forEach((s,i) => {
        let section = document.createElement("div");
        section.classList.add("product-description-section");
        if(i===0){
            section.classList.add("open");
        }
        let header = document.createElement("h3");
        header.innerText = s.header;
        section.appendChild(header);
        let contentWrapper = document.createElement("div");
        contentWrapper.classList.add("product-description-content-wrapper");
        let content = document.createElement("div");
        content.classList.add("product-description-content");
        s.content.forEach(c => {
            content.appendChild(c);
        })
        //replace all "BREAK" text with <br> elements
        $(content).html($(content).html().replace(/BREAK/g,"<br>"))
        contentWrapper.appendChild(content);
        section.appendChild(contentWrapper);
        wrapper.append(section);
        wrapper.removeClass("hidden");
    });

    console.log("sections",sections);
}

function validateEmail(email){
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

//HANK!!!!! Implement this instead
//https://developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock#client-side-request

//when .back-in-stock-form is submitted, prevent default, get email, and send to back in stock api with variant id and product id
$(document).on("submit",".back-in-stock-form",async (e)=>{
  e.preventDefault();
  let email = $(e.target).find("input[type='email']").val();
  //if email is valid, save it to loca storage as bis_email
  if(!validateEmail(email)){
    triggerAlert("Please enter a valid email address.")
    return;
  }
//   if(roucha_state.get("id").length){
//     console.log("Auto adding to wishlist");
//     //add to wishlist
//     $(".heart:not(.filled):eq(0) svg").click();
//   }
  localStorage.setItem("bis_email",email);
  let result = await BIS.create(email, variant_id, rch_product.id)
  console.log(result);
  if(result.status === "OK"){
    //if local storage doesnt have bis_signups, create it as an empty array
    if(!localStorage.bis_signups){
      localStorage.setItem("bis_signups",JSON.stringify([]));
    }
    //add the variant to local storage bis_signups
    let signups = JSON.parse(localStorage.bis_signups);
    signups.push(rch_selected_variant.id);
    localStorage.setItem("bis_signups",JSON.stringify(signups));
    $("#cart-add-button").html($("#sold-out-success").html());
  } else {
    
    triggerAlert(result.errors.base[0] ? result.errors.base[0] : "There was a problem submitting your request. Please try again.")
  }
  
})